import { render, staticRenderFns } from "./editAiAssistant.vue?vue&type=template&id=3bf8474a&lang=pug"
import script from "./editAiAssistant.vue?vue&type=script&lang=js"
export * from "./editAiAssistant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports